import { en } from './locales/en'
import { ua } from './locales/ua'

export const translations = { en, ua } as const

export type TranslationKey = keyof typeof translations.en
